import "./index.css";
import { usePath, linkProps } from "./client/lib/router";
import { Landing } from "./client/pages/Landing";
import { Login, SignUp } from "./client/pages/Auth";
import { Itinerary } from "./client/pages/Itinerary";
import { Admin } from "./client/pages/Admin";
import { Header } from "./client/components/Layout";

function NotFound() {
  return (
    <div className="mx-auto max-w-lg px-6">
      <Header />
      <div className="py-24 text-center">
        <h1 className="font-display text-5xl font-light">Lost?</h1>
        <p className="mt-4 text-muted">That page isn't part of the weekend.</p>
        <a {...linkProps("/")} className="btn btn-ghost mt-8">
          Back to the beginning
        </a>
      </div>
    </div>
  );
}

export function App() {
  const path = usePath();

  switch (path.replace(/\/+$/, "") || "/") {
    case "/":
      return <Landing />;
    case "/signup":
      return <SignUp />;
    case "/login":
      return <Login />;
    case "/rsvp":
      return <Itinerary />;
    case "/admin":
      return <Admin />;
    default:
      return <NotFound />;
  }
}

export default App;
